import axios from 'axios';
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import BaseURL from '../Utilities/BaseUrl';
import notify from '../Utilities/Notify';
import { useEffect } from 'react';
import { useState } from 'react';
import Loading from '../Loading/Loading';
import $ from 'jquery';
import WOW from 'wowjs';
import {cartContext}from'../Contexts/CartContext';
import { Helmet } from 'react-helmet';
export default function ProductDetails() {
    let {setProductInCart,loading,disable,setloading,setdisable,setcheck}=useContext(cartContext);
const wow= new WOW.WOW();

    const [myData, setmyData] = useState(null)
    let{id}=useParams();
   const [myCat, setmyCat] = useState(null)
   const [myimgs, setmyimgs] = useState([]);

   function addToCart(id) {
 
   
  
     setProductInCart(id);
  
       
  
      
   }
    function getProductDetails() {
        
        axios.get(`${BaseURL}products/${id}`).then((data)=>{
           if(data.status==200)
           {
            console.log(data);
            setmyData(data.data.data);
            setmyCat(data.data.data.category);
            setmyimgs(data.data.data.images);
            setcheck(true);
           }
        }).catch((error)=>notify('error',error));
    }

    useEffect(() => {

        setcheck(false)
        $( document ).ready(function() {
            getProductDetails();
            wow.init();



        });
    }, [])
    
  return<><Helmet>
  <title>ProductDetails</title>
  
</Helmet>
  
 {myData!=null&& myCat!=null && myimgs.length >0?  <div className="container mt-5 pt-5">
    <div className="row gy-4">
        <div className=" col-sm-6 col-md-6 col-lg-6">
            <div className="firstSection bg-transparent d-flex">
           {myimgs.length>0? <ul className='list-unstyled'>
                    {myimgs.map((item,index)=>{return<li key={index} className='mb-3 '><img src={item}alt="imageProduct" className='w-100 wow animate__animated animate__fadeInUpBig animate__delay-1s' style={{height:75}}/></li>})}
                </ul>:<Loading/>}
                <img src={myData.imageCover} alt="image type" className='w-100 ms-3' style={{height:205}}/>
                
            </div>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="secondSection">
                <h4 className='text-dark h5'>{myData.title}</h4>
                <p  className='text-muted'>{myData.description}</p>
                <p className='text-muted'>{myCat.name}</p>
                <div className="overflow-hidden ">{myData.priceAfterDiscount?<span className=" float-start ms-2"><del>{myData.price} EGP</del> {myData.priceAfterDiscount} EGP</span>:<span className=" float-start ms-2">{myData.price} EGP</span>}<span className=" float-end me-2"><i className="fa-solid fa-star text-warning me-2"></i>{myData.ratingsAverage}</span></div>
                <button type="button " className="btn bg-main w-100 mt-2" disabled={loading&&disable} onClick={()=>{
            addToCart(myData._id)
          }}>{loading&&disable?<span className="spinner-border spinner-border-sm"></span>:'Add Product'}</button>

            </div>
        </div>
    </div>
  </div>:<Loading/>}
  
  </>
}
